import { commonNextEnv } from '@repo/env/client';

export const WEB_ROUTE_PATHS = {
  home: () => '/',
  blog: {
    base: () => '/blog',
    post: (slug: string) => `/blog/${slug}`,
  },
  pricing: () => '/pricing',
  about: () => '/about',
  contact: () => '/contact',
  catalog: {
    base: () => '/catalog',
    product: (slug: string) => `/catalog/${slug}`,
  },
  legal: {
    base: () => '/legal',
    post: (slug = ':slug') => `/legal/${slug}`,
    privacy: () => '/legal/privacy-policy',
    terms: () => '/legal/terms-and-conditions',
    disclaimer: () => '/legal/disclaimer',
    cookie: () => '/legal/cookie',
  },
};

export const INTERNAL_SERVICES_HOSTS = {
  web: `${commonNextEnv().NEXT_PUBLIC_APP_PROTOCOL}://${commonNextEnv().NEXT_PUBLIC_APP_HOST}`,
  app: `${commonNextEnv().NEXT_PUBLIC_APP_PROTOCOL}://app.${commonNextEnv().NEXT_PUBLIC_APP_HOST}`,
  docs: `${commonNextEnv().NEXT_PUBLIC_APP_PROTOCOL}://docs.${commonNextEnv().NEXT_PUBLIC_APP_HOST}`,
};
